import React from 'react';
import {createRoot} from 'react-dom/client';
import {flushSync} from 'react-dom';
import {QRCodeSVG} from 'qrcode.react';
import {dibujarQrVectorial} from './qrVectorial';

export function imagenQrRecibo(value){
 const host=document.createElement('div');
 const root=createRoot(host);
 try{
  flushSync(()=>root.render(<QRCodeSVG value={value} size={768} marginSize={4} level="M"/>));
  const canvas=document.createElement('canvas');canvas.width=768;canvas.height=768;
  const ctx=canvas.getContext('2d');
  ctx.fillStyle='#fff';ctx.fillRect(0,0,768,768);
  dibujarQrVectorial(ctx,host.querySelector('svg'),{x:0,y:0,width:768,height:768},1);
  return canvas.toDataURL('image/png');
 }finally{root.unmount();}
}
